import type { TabParamList } from '../types'

export const getTabBarVisibilityStyle = (hideTabBar: boolean, routeName: keyof TabParamList) =>
  hideTabBar && routeName === 'Nora' ? ({ display: 'none' } as const) : {}
